import styled from 'styled-components'

export const FeedbackBlockWrapper = styled('div')`
  width: 100%;
  padding-top: 1.25rem;
  white-space: pre-wrap;
`
